<template>
  <div class="select-option-container">
    <button type="button" class="btn btn-link btn-close" @click.stop="onRemoved" v-if="!disabledDeleteButton">
      <i class="fas fa-times"></i>
    </button>
    <multiselect
      :value="value"
      :options="options"
      :placeholder="placeholder"
      :label="label"
      :showLabels="false"
      :multiple="isMultiple"
      :disabled="disabled"
      :maxHeight="maxHeight"
      :allow-empty="allowEmpty"
      @input="onSelected"
      @search-change="onSearchChange"
      open-direction="bottom">
      <template slot="noResult" slot-scope="props">
        <span class="no-result">ไม่พบ '{{props.search}}' ที่กำลังค้นหา</span>
      </template>
      <span slot="caret"
        class="arrow">
        <i class="fas fa-angle-down"></i>
      </span>
    </multiselect>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect';

export default {
  components: { Multiselect },
  props: {
    value: {
      type: [Object, Array],
      default: () => {},
    },
    options: {
      type: Array,
      default: () => [],
    },
    placeholder: {
      type: String,
      default: 'เลือกแท็ก',
    },
    label: {
      type: String,
      default: 'name',
    },
    trackBy: {
      type: String,
      default: 'name',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    maxHeight: {
      type: Number,
      default: 300,
    },
    disabledDeleteButton: {
      type: Boolean,
      default: false,
    },
    allowEmpty: {
      type: Boolean,
      default: true,
    },
    isMultiple: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onSelected(selectedOption) {
      this.$emit('onChanged', selectedOption);
    },
    onRemoved() {
      this.$emit('onChanged', null);
    },
    onSearchChange(q) {
      this.$emit('onSearch', { q });
    },
  },
};
</script>

<style lang="scss" scoped>
  .select-option-container {
    .btn-close {
      padding: 0.375rem 0;
      right: 30px;
    }
  }
</style>
